import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M15 16L11 20H21V16H15Z" fill="black"/>
<path d="M12.06 7.18994L3 16.2499V19.9999H6.75L15.81 10.9399L12.06 7.18994ZM5.92 17.9999H5V17.0799L12.06 10.0199L12.98 10.9399L5.92 17.9999Z" fill="black"/>
<path d="M18.7099 8.04C19.0999 7.65 19.0999 7.02 18.7099 6.63L16.3699 4.29C16.1699 4.09 15.9199 4 15.6599 4C15.4099 4 15.1499 4.1 14.9599 4.29L13.1299 6.12L16.8799 9.87L18.7099 8.04Z" fill="black"/>
</svg>
;
